import type { Station } from '@/content/schema';

const clamp01 = (v: number) => Math.min(1, Math.max(0, v));

// 0..1 across the station's waypoint span, starting a little before the first waypoint
export function stationTimeAt(station: Station, progress: number): number {
  const first = station.waypoints[0]!.at;
  const last = station.waypoints[station.waypoints.length - 1]!.at;
  const span = Math.max(last - first, 1e-4);
  const lead = span * 0.35;
  return clamp01((progress - (first - lead)) / (span + lead));
}

export interface StationFx {
  build: number;
  xray: number;
}

export function stationFxAt(station: Station, progress: number): StationFx {
  const t = stationTimeAt(station, progress);
  return {
    build: station.fx.build ? clamp01(t / 0.45) : 1,
    xray: station.fx.xray ? clamp01((t - 0.55) / 0.4) : 0,
  };
}
